import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './BottomNav.css';
import Icon from '../common/Icon';

const KEYBOARD_MIN_HEIGHT_PX = 150;

const getTabs = (role) => [
    {
        to: role === 'master' ? '/my-day' : '/dashboard',
        label: 'Сегодня',
        icon: 'today',
        paths: role === 'master' ? ['/my-day'] : ['/dashboard', '/'],
    },
    { to: '/orders', label: 'Заказы', icon: 'orders', prefix: '/orders' },
    { to: '/clients', label: 'Клиенты', icon: 'clients', prefix: '/clients' },
    { to: '/materials', label: 'Склад', icon: 'box', prefix: '/materials' },
];

const isTabActive = (tab, pathname) => (
    tab.paths ? tab.paths.includes(pathname) : pathname === tab.prefix || pathname.startsWith(`${tab.prefix}/`)
);

const useKeyboardVisible = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const viewport = window.visualViewport;
        if (!viewport) return undefined;

        const update = () => {
            // При масштабировании страницы видимая область тоже сжимается, это не клавиатура
            const isZoomed = viewport.scale > 1.01;
            setVisible(!isZoomed && window.innerHeight - viewport.height > KEYBOARD_MIN_HEIGHT_PX);
        };

        update();
        viewport.addEventListener('resize', update);
        return () => viewport.removeEventListener('resize', update);
    }, []);

    return visible;
};

const BottomNav = ({ role, isMenuOpen, onMenuToggle }) => {
    const { pathname } = useLocation();
    const keyboardVisible = useKeyboardVisible();

    if (keyboardVisible) {
        return null;
    }

    const tabs = getTabs(role);
    const isOnTab = tabs.some((tab) => isTabActive(tab, pathname));

    return (
        <nav className="bottom-nav" aria-label="Основная навигация">
            {tabs.map((tab) => (
                <NavLink
                    key={tab.label}
                    to={tab.to}
                    className="bottom-nav-item"
                    activeClassName="active"
                    isActive={(_match, location) => isTabActive(tab, location.pathname)}
                >
                    <Icon name={tab.icon} size={20} />
                    <span>{tab.label}</span>
                </NavLink>
            ))}
            <button
                type="button"
                className={`bottom-nav-item${isMenuOpen || !isOnTab ? ' active' : ''}`}
                onClick={onMenuToggle}
                aria-expanded={Boolean(isMenuOpen)}
            >
                <Icon name="menu" size={20} />
                <span>Ещё</span>
            </button>
        </nav>
    );
};

export default BottomNav;
